export default "__VITE_ASSET__RFVp3twt__"